<script lang="ts">
    import {onMount} from "svelte";

    export let spaceCompanyDepartments;

    onMount(() => {
    });


</script>

<div class="space-company-department-area">
    <div class="title">会社部署</div>
    <ul class="space-company-departments">
        {#each spaceCompanyDepartments as spaceCompanyDepartment}
            <li class="space-company-department">
                <span>{spaceCompanyDepartment.company_name}</span>

                {#if spaceCompanyDepartment.department_name != null}
                    <span>{spaceCompanyDepartment.department_name}</span>
                {/if}
                <span> 所属</span>
            </li>
        {/each}
    </ul>
</div>
<style lang="scss">
    .template-view {

    }
</style>